import React, { useCallback, useEffect, useState } from 'react';
import {
    LuCalendarDays,
    LuChevronLeft,
    LuChevronRight,
    LuMenu,
    LuShoppingCart,
    LuX
} from 'react-icons/lu';
import { MdOutlineRoomService, MdOutlineShoppingCart } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactSVG } from 'react-svg';
import { useMediaQuery } from 'usehooks-ts';
import { VerReservasHeaderTrigger } from '@/components/OwnerReservationsPanel';
import { isProprietarioProfile } from '@/helpers/accessProfileUtil';
import { Render } from '../../../../helpers/Render';
import {
    canAccessStore,
    STORE_RESERVATION_REQUIRED_MESSAGE,
} from '../../../../helpers/storeAccess';
import { useUserProfile } from '../../../../hooks/useUserData';
import { useModalAuthStore } from '../../../../store/auth/authModalStore';
import { useModalParkStore } from '../../../../store/park/modalParkStore';
import { useReservationStore } from '../../../../store/reservation/reservationStore';
import { useModalShoppingStore } from '../../../../store/shopping/modalShoppingStore';
import { useShoppingCartStore } from '../../../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../../../BigButton';
import { Drawer } from '../../../Drawer';
import ReactIcon from '../../../ReactIcon';
import UserOptionsDropdown from '../../../UserOptionsDropdown';
import {
    LogoHeader,
    Separator,
    TextIconNav,
    WrapHeaderSmall,
    WrapValuesNav,
    WrapValuesNavShop,
} from './styles';

type HeaderSmallProps = {
    onOpenOwnerReservations?: () => void;
};

export const HeaderSmall: React.FC<HeaderSmallProps> = ({
    onOpenOwnerReservations,
}) => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuShop, setMenuShop] = useState(false);
    const { setIsVisibleShoppingWave } = useModalShoppingStore();
    const { setIsVisiblePark } = useModalParkStore();
    const activeReservation = useReservationStore(state => state.activeReservation);
    const { cartValues } = useShoppingCartStore();
    const totalItemsInCart = cartValues?.length || 0;
    const matchQuery = useMediaQuery('(min-width: 1024px)');
    const userProfile = useUserProfile();
    const user = userProfile.data;
    const { setIsVisibleAuthModal: setAuthOpen } = useModalAuthStore();

    const handleChangeMenu = useCallback(() => {
        setMenuOpen(prev => !prev);
    }, []);

    const handleChangeMenuShop = useCallback(() => {
        setMenuShop(prev => !prev);
    }, []);

    const scrollToFooter = () => {
        const footerElement = document.getElementById('contatos-footer');
        if (footerElement) {
            footerElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    useEffect(() => {
        if (!menuOpen) setMenuShop(false);
        if (matchQuery && menuOpen) setMenuOpen(false);
    }, [matchQuery, menuOpen]);

    const handleOpenStore = () => {
        if (!canAccessStore({ activeReservation })) {
            toast.warning(STORE_RESERVATION_REQUIRED_MESSAGE);
            return;
        }
        setIsVisibleShoppingWave(true);
    };

    return (
        <>
            <WrapHeaderSmall>
                <LogoHeader onClick={() => navigate('/')}>
                    <ReactSVG src="./images/Logo.svg" />
                </LogoHeader>

                <section>
                    {user &&
                        isProprietarioProfile(user) &&
                        onOpenOwnerReservations && (
                            <VerReservasHeaderTrigger
                                compact
                                onClick={onOpenOwnerReservations}
                            />
                        )}
                    <ReactIcon
                        Icon={MdOutlineShoppingCart}
                        size={'1.5rem'}
                        cursor={'pointer'}
                        color="white"
                        onClick={handleOpenStore}
                    />
                    <Separator></Separator>
                    <ReactIcon
                        Icon={menuOpen ? LuX : LuMenu}
                        color="white"
                        size={'1.5rem'}
                        cursor={'pointer'}
                        onClick={() => setMenuOpen(prev => !prev)}
                        className="menu-icon"
                    />
                </section>
            </WrapHeaderSmall>

            {/* Drawer para as telas menores */}
            <Drawer
                isOpen={menuOpen}
                toggleDrawer={handleChangeMenu}
                stylesDrawer={{ marginTop: '4rem' }}
                drawerClassName="nav-options-drawer"
            >
                {/* Nav Values das telas menores */}

                <Render show={!menuShop}>
                    <WrapValuesNav aria-selected={!menuShop}>
                        <TextIconNav
                            onClick={() => {
                                handleOpenStore();
                                setMenuOpen(false);
                            }}
                        >
                            <ReactIcon Icon={LuShoppingCart} size={'1.25rem'} />
                            <p>Seu carrinho ({totalItemsInCart})</p>
                        </TextIconNav>
                        <TextIconNav
                            onClick={() => {
                                window.open(
                                    'https://mkt.surflandbrasil.com.br/multipropriedade',
                                    '_blank'
                                );
                            }}
                        >
                            <p>Seja Proprietário</p>
                        </TextIconNav>
                        <TextIconNav onClick={handleChangeMenuShop}>
                            <p>Loja</p>
                            <ReactIcon Icon={LuChevronRight} size={'1.25rem'} />
                        </TextIconNav>
                        <TextIconNav onClick={scrollToFooter}>
                            <p>Contatos</p>
                        </TextIconNav>
                        {user &&
                            isProprietarioProfile(user) &&
                            onOpenOwnerReservations && (
                                <TextIconNav
                                    onClick={() => {
                                        onOpenOwnerReservations();
                                        setMenuOpen(false);
                                    }}
                                >
                                    <ReactIcon Icon={LuCalendarDays} size={'1.25rem'} />
                                    <p>Ver reservas</p>
                                </TextIconNav>
                            )}
                        {/* <TextIconNav
                            onClick={() =>
                                redirectToLink(
                                    'https://www.surflandbrasil.com.br/faq'
                                )
                            }
                        >
                            <p>Dúvidas</p>
                        </TextIconNav> */}

                        {!user && (
                            <div className="login-area">
                                <BigButton
                                    bgColor="primary"
                                    color="primary"
                                    onClick={() => setAuthOpen(true, 'signup')}
                                >
                                    Cadastre-se
                                </BigButton>
                                <BigButton
                                    bgColor="primary"
                                    color="primary"
                                    onClick={() => setAuthOpen(true, 'login')}
                                >
                                    Já sou cliente
                                </BigButton>
                            </div>
                        )}
                        {user && (
                            <UserOptionsDropdown
                                tipppyProps={{ offset: [0, 5] }}
                                className={'user-options'}
                            />
                        )}
                    </WrapValuesNav>
                </Render>

                {menuShop && (
                    <WrapValuesNavShop aria-selected={menuShop}>
                        <TextIconNav
                            isTitle
                            onClick={handleChangeMenuShop}
                            style={{
                                paddingTop: '1rem',
                                paddingBottom: '1rem',
                            }}
                        >
                            <ReactIcon Icon={LuChevronLeft} size={'1.25rem'} />
                            <p>Loja</p>
                        </TextIconNav>
                        <TextIconNav
                            onClick={() => {
                                setIsVisiblePark(true);
                                setMenuOpen(false);
                            }}
                        >
                            <ReactIcon Icon={LuShoppingCart} size={'1.25rem'} />
                            <p>Tickets</p>
                        </TextIconNav>
                        {/* <TextIconNav
                            onClick={() => {
                                setIsVisibleServices(true);
                                setMenuOpen(false);
                            }}
                        >
                            <ReactIcon
                                Icon={MdOutlineRoomService}
                                size={'1.25rem'}
                            />
                            <p>Serviços</p>
                        </TextIconNav> */}
                        <TextIconNav onClick={handleChangeMenu}>
                            <ReactIcon
                                Icon={MdOutlineRoomService}
                                size={'1.25rem'}
                            />
                            <p>Serviços</p>
                        </TextIconNav>
                    </WrapValuesNavShop>
                )}
            </Drawer>
        </>
    );
};
